import { render, staticRenderFns } from "./LinkAccountWarningModal.vue?vue&type=template&id=44852928&"
import script from "./LinkAccountWarningModal.vue?vue&type=script&lang=ts&"
export * from "./LinkAccountWarningModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports